import React from "react";
import HeroSection from "./HeroSection";
import ExamsSection from "./ExamsSection";
import AboutBenefit from "./AboutBenefit";
import Footer from "./Footer"

function LandingPage() {
  return (
    <>
      <HeroSection />
      <ExamsSection />
      <AboutBenefit />
      <Footer />
    </>
  );
}

export default LandingPage;
